<template>
  <drag-dialog
    :visible.sync="visible"
    :title="`【${projectName}】新增/删除检测项目`"
    width="100vw"
    height="100vh"
    :before-close="() => $emit('update:visible', false)"
    @close="$dialogFormReset()"
  >
    <table v-loading="detailLoading" class="word-table">
      <tr style="background-color: #f2f2f2">
        <td width="15%" class="label">检测项目</td>
        <td width="7%" class="label">数量</td>
        <td width="12.5%" class="label">试验项目</td>
        <td width="25%" class="label">现场图片</td>
        <td width="20%" class="label">检测清单</td>
        <td width="12.5%" class="label">工作量备注</td>
        <td width="8%" class="label">
          <el-button type="primary" size="mini" icon="el-icon-plus" circle @click="handleSampleAdd"></el-button>
        </td>
      </tr>
      <tr v-for="(item, index) in sampleInfoList" :key="index">
        <td class="align-Left">{{ item.testItemText }}</td>
        <td>
          <el-input :disabled="!item.isNew && editIndex != index" type="number" v-model="item.cnt" style="width: 100%"></el-input>
        </td>
        <td>
          <el-input
            :disabled="!item.isNew && editIndex != index"
            type="textarea"
            v-model="item.expItems"
            :rows="4"
            style="width: 100%"
          ></el-input>
        </td>
        <td>
          <div v-if="!item.isNew && editIndex != index" class="img-list">
            <el-image
              v-for="(url, imgIndex) in item.imgList"
              :key="imgIndex"
              style="width: 88px; height: 88px"
              :src="url"
              :preview-src-list="item.imgList"
            ></el-image>
          </div>
          <image-upload v-else v-model="item.imgs" :modelType="2" :paramsData="{ type: 'upt_img' }"></image-upload>
        </td>

        <td>
          <div v-if="!item.isNew && editIndex != index" class="file-list">
            <el-link
              type="primary"
              :underline="true"
              v-for="(file, index) in item.files"
              :key="index"
              :href="`${$imgUrl}${file.filePath}`"
              target="_blank"
            >
              {{ file.fileName }}
            </el-link>
          </div>
          <upload-button v-else v-model="item.files" :fileSize="50" :paramsData="{ type: 'upt_file' }"></upload-button>
        </td>
        <td>
          <el-input
            :disabled="!item.isNew && editIndex != index"
            type="textarea"
            v-model="item.remark"
            :rows="4"
            style="100"
          ></el-input>
        </td>
        <td>
          <el-button type="danger" size="mini" icon="el-icon-delete" circle @click="handleSampleDel(index, item)"></el-button>
          <template v-if="item.isNew">
            <br />
            <el-button style="margin-top: 14px" :loading="submitLoading" type="primary" @click="handleSubmit">确认添加</el-button>
          </template>
          <el-button
            v-else
            type="primary"
            size="mini"
            icon="el-icon-edit-outline"
            circle
            @click="handleSampleEdit(index, item)"
          ></el-button>

          <template v-if="editIndex == index">
            <br />
            <el-button
              v-loading="editLoading"
              style="margin-top: 14px"
              :loading="submitLoading"
              type="primary"
              @click="handleSubmitEdit(index, item)"
            >
              确认编辑
            </el-button>
          </template>
        </td>
      </tr>
    </table>

    <div slot="footer">
      <el-button @click="$emit('update:visible', false)">关 闭</el-button>
    </div>

    <!-- 选择样品 -->
    <SampleSelect :visible.sync="sampleVisible" @setItemList="sampleCallback"></SampleSelect>
  </drag-dialog>
</template>

<script>
import SampleSelect from '@/views/system/sample/components/SampleSelect';
import ImageUpload from '@/components/UploadArea/ImageUpload';
import UploadButton from '@/components/UploadArea/UploadButton';

import { getItem } from '@/api/system';
import { getEntrustmentSet, addEntrustmentJson, editSampleInfo } from '@/api/entrust';
import { editFlowState } from '@/api/flow';

export default {
  components: { SampleSelect, ImageUpload, UploadButton },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    activeId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      projectName: '',
      sampleInfoList: [],
      detailLoading: false,
      submitLoading: false,
      sampleVisible: false,
      editIndex: null,
      editLoading: false
    };
  },
  computed: {},
  watch: {
    async visible(val) {
      if (val) {
        if (this.activeId) {
          this.getDetailData();
        }
      }
    }
  },
  methods: {
    // 编辑时获取详情
    async getDetailData() {
      this.detailLoading = true;

      try {
        const { data } = await getEntrustmentSet({ id: this.activeId });

        const sampleInfoList = data?.sampleInfoList || [];
        sampleInfoList.forEach(item => {
          if (item.imgs) {
            if (this.isJSONObjectOrArray(item.imgs)) {
              const allFiles = JSON.parse(item.imgs);
              item.imgs = allFiles.imgs;

              if (allFiles.imgs) {
                item.imgList = allFiles.imgs.split(',').map(item => {
                  return this.$imgUrl + item;
                });
              }
              item.files = allFiles?.files || [];
            } else {
              item.imgs = item.imgs;
              item.imgList = item.imgs.split(',').map(item => {
                return this.$imgUrl + item;
              });
              item.files = [];
            }
          } else {
            item.imgs = '';
            item.imgList = [];
            item.files = [];
          }
        });
        this.sampleInfoList = sampleInfoList;
        this.projectName = data?.projectName || '';
      } finally {
        this.detailLoading = false;
      }
    },
    isJSONObjectOrArray(str) {
      if (typeof str !== 'string') return false;
      try {
        const parsed = JSON.parse(str);
        return typeof parsed === 'object' && parsed !== null;
      } catch (e) {
        return false;
      }
    },
    handleSampleAdd() {
      if (this.sampleInfoList.some(item => item.isNew)) return this.$message.warning('每次仅可新增一条检测项目！');
      this.sampleVisible = true;
    },
    sampleCallback(sampleList) {
      if (sampleList.length > 1) {
        this.$message.warning('每次仅可新增一条检测项目！');
        this.$nextTick(() => {
          this.sampleVisible = true;
        });
        return;
      }
      const processSamples = async () => {
        const processedSamples = await Promise.all(
          sampleList.map(async item => {
            const basisList = await this.getItemBasis(item.testItemId);
            const testItems = basisList.map(basis => {
              return {
                sampleName: item.remark,
                itemId: item.testItemId,
                itemName: item.testItem,
                sampleId: item.id,
                basisId: basis.basisId,
                basisCode: '',
                basisName: basis.basisName
              };
            });
            return {
              sampleId: item.id,
              sampleName: item.remark,
              cnt: 1,
              testItemText: item.testItem || '',
              testItems: JSON.stringify(testItems), // 将basisList转换为JSON字符串存储
              expItems: '',
              imgs: '',
              files: [],
              remark: '',
              isNew: true
            };
          })
        );

        this.sampleInfoList = [...this.sampleInfoList, ...processedSamples];
      };

      processSamples();
    },
    async getItemBasis(id) {
      const { data } = await getItem({ id });

      const basisList = data.basisList ?? [];
      return basisList;
    },
    handleSampleDel(index, item) {
      if (item.isNew) {
        this.sampleInfoList.splice(index, 1);
      } else {
        this.$confirm('您确定删除所选委托吗？删除后不可恢复！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(async () => {
            await editFlowState({ entrustmentId: item.entrustmentId, reason: '删除委托', state: -2 });
            this.sampleInfoList.splice(index, 1);
            this.$message.success('删除成功');
            this.$emit('refresh');
          })
          .catch(() => {});
      }
    },
    handleSampleEdit(index, item) {
      if (this.editIndex) return this.$message.warning('每次只能编辑一条样品信息！');
      this.editIndex = index;
    },
    async handleSubmitEdit(index, item) {
      if (!item.cnt) return this.$message.warning('请输入样品数量！');
      try {
        this.editLoading = true;
        const imgs = JSON.stringify({
          imgs: item.imgs,
          files: item?.files || []
        });
        await editSampleInfo({ ...item, imgs });
        this.$message.success('编辑成功');
        this.editIndex = null;
        this.getDetailData();
      } finally {
        this.editLoading = false;
      }
    },
    async handleSubmit() {
      if (!this.sampleInfoList.some(item => item.isNew)) return this.$message.warning('请添加样品信息！');

      this.submitLoading = true;

      // 处理样品信息
      const sampleInfoListValue = this.sampleInfoList
        .filter(item => item.isNew)
        .map((item, index) => {
          const imgs = JSON.stringify({
            imgs: item.imgs,
            files: item?.files || []
          });

          return {
            ...item,
            imgs,
            eng: index + 1
          };
        });

      const params = {
        mainId: this.activeId,
        sampleInfoList: sampleInfoListValue
      };
      try {
        await addEntrustmentJson(params);
        this.$message.success('提交成功!');
        this.getDetailData();
        this.$emit('refresh');
      } finally {
        this.submitLoading = false;
      }
    }
  },

  created() {},
  mounted() {}
};
</script>

<style lang="scss" scoped>
.el-button--mini.is-circle {
  padding: 5px;
}

.el-select {
  width: 100%;
}

.break-radio {
  .el-radio {
    margin-bottom: 10px;
  }
  .radio-line {
    display: flex;
    align-items: center;
    .el-radio {
      margin-bottom: 0;
    }
  }
}
.img-list {
  display: flex;
  flex-wrap: wrap;
  .el-image {
    margin: 0 10px 10px 0;
    background-color: #fbfdff;
    border: 1px dashed #c0ccda;
    border-radius: 6px;
  }
}
</style>
